import {Component, Input} from '@angular/core';
import {EventCreationModel} from "../../_models/event-creation-model";
import {WeekdayLabels} from "../../../../x-models/x-enums/weekdays";
import {WeekdayEventViewComponent} from "../weekday-event-view/weekday-event-view.component";
import {EventCreationVerdict} from "../../_models/event-creation-verdict";

@Component({
  selector: 'location-weekday-view',
  imports: [
    WeekdayEventViewComponent
  ],
  templateUrl: './weekday-view.component.html',
  styleUrl: './weekday-view.component.scss'
})
export class WeekdayViewComponent {
  @Input() events_grouped!: { [key: string]: EventCreationModel[] }

  /**
   * The server's dry-run verdict per occurrence (#664), keyed by the very model objects this view renders.
   *
   * Keyed by object identity rather than by index or name so the view cannot mislabel a row: the map is built
   * from the same array the grouping was built from, and an occurrence with no entry simply shows no verdict.
   * Optional, because the preview also opens in tests and stories that have no dry run behind them.
   */
  @Input() verdicts?: Map<EventCreationModel, EventCreationVerdict>;

  protected get weekdays(): number[] {
    return Object.keys(this.events_grouped).map(key => parseInt(key));
  }

  protected verdictOf(event: EventCreationModel): EventCreationVerdict | undefined {
    return this.verdicts?.get(event);
  }

  protected readonly WeekdayLabels = WeekdayLabels;
}
